import React from 'react'
import Link from 'redux-first-router-link'
import SimpleFrame from '../components/frame/SimpleFrame'
import { goToAdventure, goToSettings } from '../redux/actions/routing/route.actions'

function Home() {
    return (
        <SimpleFrame>
            <div className="scene--base scene__home">
                <span className="game__title--background">test</span>
                <h1 className="game__title">
                    <span className="game__title--clash">Clash</span>
                    <span className="game__title--of">of</span>
                    <span className="game__title--emoji">Emoji</span>
                    <span className="game__title--poo" role="img" aria-label="poo">💩</span>
                    <span className="game__title--bomb" role="img" aria-label="da bomb">💣</span>
                    <em className="game__title--alpha"> (αlpha)</em>
                </h1>
                <div className="game__title--buttons">
                    <Link className="buttonLink--wrapper" to={goToAdventure()}>
                        <button className="button--base" type="button">Start</button>
                    </Link>
                    <Link className="buttonLink--wrapper" to={goToSettings()}>
                        <button className="button--base" type="button">Settings</button>
                    </Link>
                </div>
            </div>
        </SimpleFrame>
    )
}

export default Home
